module.exports={
    message: {
        header_menu:{
            bigrow: '无极大排',
            service:'驾驭美学',
            shop: "官方商城",
            contact_us: "无极服务",
            news_list: "品牌动态",
            post_bar: "车友论坛"
        },
        submenu_bigrow:{
            menu01:'跑车（RR）系列',
            menu02:'街车（RR）系列',
            menu03:'复古（AC）系列',
            menu04:'拉力（DS）系列'
        },
        submenu_service:{
            introduction:'公司简介',
            story:'品牌故事',
            note:'历史事纪',
            conversation:'品牌荣誉',
        },
        submenu_shop:{
            tm_shop:'天猫商城',
            jd_shop:'京东商城'
        },
        submenu_contact_us:{
            dot_query:'网点查询',
            repair:'一键报修',
            download:'APP下载'
        },
        submenu_news_list:{
            newest:'最新资讯',
            video:'精彩视频'
        },
        submenu_post_bar:{
            latest_topics:'最新话题',
            communication:'车友交流',
            release:'官方发布',
            teaching:'视频教学'
        },
        wjfw:{
            wdcx:'网点查询',
            yjbx:'一键报修',
            wjzs:'无极招商',
            wjapp:'无极APP',
            dzb:'使用说明'
        },
        mtzx:{
            zxzx:'最新资讯',
            jcsp:'精彩视频',
            cylt:'车友论坛'
        },
        zxsc:{
            tm_shop:'天猫商城',
            jd_shop:'京东商城'
        },
        gywm:{
            ppgs:'品牌故事',
            lssj:'历史事记'
        },
        footer:{
            about:'关于我们',
            help:'帮助中心',
            after_sale:'售后与支持',
            wx:'微信公众号',
            wb:'新浪微博',
            ser_tel:'客服热线',
            friendLink:"友情链接",
            links:"哈罗摩托",
            shop:'在线商城',
            mediaCenter:'媒体中心',
            wuService:'无极服务',
        },
        home_page:{
            keyword:'请输入查询内容',
            related_title:'新品优惠',
            hot_title:'热门配件',
            active_title:'活动专区',
            service:{
                service_title:'售后服务',
                contact_title:'联系我们',
            }
        },
        brand_page:{
            culture:'企业文化',
            event:'无极大事件',
            future:'未来景愿',
        },
        service_page:{
            service_introduce:'服务介绍',
            keep:'保养计划',
            service_details1:'整车盗抢赔付',
            service_details2:'第三者伤害赔付',
            service_details3:'驾驶人意外伤害赔付',
            service_details4:'服务保障条款',
            service_details5:'免责条款',
        },
        contact_us_page:{
            apply_btn:'立即申请加盟',
            all_store:'全部线下门店',
            name:'请输入姓名',
            tel:'请输入联系电话',
            email:'请输入邮箱',
            thing:'请输入所咨询的事情',
            sub:'确定提交',
        },
        same:{
            company:'公司简介',
            sen_title:'无极保',
        },
    }
}



//////////////////
// WEBPACK FOOTER
// ./lang/cn/index.js
// module id = Cz88
// module chunks = 1